<template>
  <v-dialog v-model="show"
            width="337"
            content-class="modal interaction">
    <div class="usage-terms-preview">
      <section class="usage-terms-preview-header">
        <h1 ref="termTitle"
            class="usage-terms-preview-header-title"></h1>
        <div class="line"></div>
      </section>

      <section ref="termContent"
               class="usage-terms-preview-text">
      </section>

      <section v-if="hasOptInActive"
               class="usage-terms-preview-concent">
        <div class="radio"></div>

        <span ref="termOptIn"
              id="concentText">
          Aceito receber todo o conteúdo sobre Marcas, Produtos, Programas de
          Fidelidade, Ofertas, Promoções e Eventos dos anunciantes parceiros
          ao WiFeed, via meios de contato por mim inseridos ativamente, tais
          como e-mail e celular.
        </span>
      </section>

      <div class="usage-terms-preview-actions">
        <button class="usage-terms-preview-actions-action "
                disabled>
          Aceitar
        </button>
      </div>
    </div>
  </v-dialog>
</template>

<script>

export default {
  components: {},

  data() {
    return {
      show: false,
    };
  },

  props: {
    term: {
      type: Object,
    },
  },

  computed: {
    hasOptInActive() {
      return this.term.optinText !== null;
    },
  },

  methods: {
    open() {
      this.show = true;
    },
  },

  mounted() {
    if (this.term) {
      this.$refs.termContent.innerHTML = this.term.content;
      this.$refs.termTitle.innerHTML = this.term.title;
      if (this.hasOptInActive) {
        this.$refs.termOptIn.innerHTML = this.term.optinText;
      }
    }
  },

  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
.usage-terms-preview {
  height: 100%;
  width: 100%;
  background-repeat: repeat !important;
  background: linear-gradient(0deg, #092f39, #497461) !important;
  display: flex;
  flex-direction: column;
  color: white;

  .usage-terms-preview-header {
    position: relative;

    .usage-terms-preview-header-title {
      text-align: center;
      margin: 20px auto 0;
      font-weight: 700;
      color: white;
      font-size: 25px;
      white-space: normal;
      line-height: inherit;
    }

    .line {
      margin: 0 auto 30px;
      width: 50%;
      border-bottom: 1px solid white;
    }
  }

  .usage-terms-preview-text {
    flex: 6;
    font-size: 11px;
    margin: 0 auto;
    overflow-y: scroll;
    width: 90%;
    overflow-x: hidden;
  }

  .usage-terms-preview-concent {
    padding: 20px 0 0 0;
    width: 90%;
    margin: 0 auto;
    font-size: 9px;
    display: flex;
    align-items: center;

    .radio {
      flex-shrink: 0;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      border: 1px solid white;
      margin-right: 10px;
    }
  }

  .usage-terms-preview-actions {
    display: flex;
    align-items: center;
    flex: 1;

    .usage-terms-preview-actions-action {
      font-size: 12px;
      font-weight: 400;
      color: #474747;
      background: white;
      margin: 0 auto;
      width: 120px;
      border-radius: 20px;
      height: 25px;
    }
  }

  #concentText {
    word-break: break-all;
  }
}
</style>
